// TODO MOP-86 Add Posthog

export function createLogger({environment}) { }

export function setUser(logger, userId, userEmail) { }

export function sendError(logger, error) { }